export const formatLikesCount = (likes?: number): number | string => {
  if (!likes || likes < 1000) {
    return likes ?? 0;
  }

  const thousands = Math.floor(likes / 1000);
  const hundreds = Math.floor((likes % 1000) / 100);

  return hundreds ? `${thousands}.${hundreds}к` : `${thousands}к`;
};
export const formatLikesCount = (likes?: number): number | string => {
  if (!likes || likes < 1000) {
    return likes ?? 0;
  }

  const thousands = Math.floor(likes / 1000);
  const hundreds = Math.floor((likes % 1000) / 100);

  return hundreds ? `${thousands}.${hundreds}к` : `${thousands}к`;
};
